import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setAccessLoading = (data) => (dispatch) => {
  dispatch({
    type: types.AccessTypes.ACCESS_SET_LOADING,
    payload: data
  });
};

// set  create loading
const setAccessCreateLoading = (data) => (dispatch) => {
  dispatch({
    type: types.AccessTypes.ACCESS_SET_CREATE_LOADING,
    payload: data
  });
};

// clear result
const clearAccessResult = () => (dispatch) => {
  dispatch({
    type: types.AccessTypes.ACCESS_CLEAR_RESULT
  });
};

// clear error
const clearAccessErrors = () => (dispatch) => {
  dispatch({
    type: types.AccessTypes.ACCESS_CLEAR_ERRORS
  });
};

// unmount result
const unmountAccessData = () => (dispatch) => {
  dispatch({
    type: types.AccessTypes.ACCESS_UNMOUNT
  });
};

const selectedModuleAccess =
  (selectedAccessModuleInput) => (dispatch) => {
    dispatch({
      type: types.AccessTypes.SELECTED_MODULE_ACCESS,
      payload: selectedAccessModuleInput
    });
  };

// change access user
const changeAccess = () => async (dispatch) => {
  try {
    window.localStorage.removeItem("moduleType");
    window.localStorage.removeItem("locationId");
    window.localStorage.removeItem("locationName");
  } catch (accessError) {
    const errorData = {
      data: accessError.response.data,
      status: accessError.response.status
    };
    dispatch({
      type: types.AccessTypes.ACCESS_GET_ERRORS,
      payload: errorData
    });
  }
};

// get function
const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

const getAccessData =
  (locationName, loginType) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Access_Api.GET_ALL_ACCESS_API}/${locationName}`;
    dispatch({
      type: types.AccessTypes.ACCESS_INPUT,
      payload: { locationId: locationName }
    });
    const type = types.AccessTypes.GET_ALL_ACCESS;
    const errorType = types.AccessTypes.ACCESS_GET_ERRORS;
    getFunction(url, type, errorType, dispatch);
  };

const getEmployeeAccess = (userId, loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Access_Api.GET_EMPLOYEE_ACCESS_API}/${userId}`;
  const type = types.AccessTypes.GET_EMPLOYEE_ACCESS;
  const errorType = types.AccessTypes.ACCESS_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// create access
const createAccessControl =
  (accessData, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const url = `${baseUrlNode}${api.Access_Api.ADD_ACCESS_API}/${loginType}`;
      const addAccessSuccess = await axios.post(url, accessData);
      dispatch({
        type: types.AccessTypes.ADD_ACCESS,
        payload: addAccessSuccess.data
      });
    } catch (addAccessError) {
      const errorData = {
        data: addAccessError.response.data,
        status: addAccessError.response.status
      };
      dispatch({
        type: types.AccessTypes.ACCESS_GET_ERRORS,
        payload: errorData
      });
    }
  };

// get all user by location id and logint type for access
const getAllUsersForAccess =
  (loginType, locationId) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Access_Api.GET_ALL_USERS_FOR_ACCESS_API}/${loginType}/${locationId}`;
    const type = types.UserTypes.GET_USERS_FOR_ACCESS;
    const errorType = types.UserTypes.USER_GET_ERRORS;
    dispatch({
      type: types.AccessTypes.ALL_INPUTS,
      payload: { locationId }
    });
    getFunction(url, type, errorType, dispatch);
  };

const deleteAccessControl =
  (removeAccessData, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const url = `${baseUrlNode}${api.Access_Api.DELETE_ACCESS_API}/${loginType}`;
      const deleteAccessSuccess = await axios.post(
        url,
        removeAccessData
      );
      dispatch({
        type: types.AccessTypes.DELETE_ACCESS,
        payload: deleteAccessSuccess.data
      });
    } catch (deleteAccessError) {
      const errorData = {
        data: deleteAccessError.response.data,
        status: deleteAccessError.response.status
      };
      dispatch({
        type: types.AccessTypes.ACCESS_GET_ERRORS,
        payload: errorData
      });
    }
  };

// get all - updates
const getAllUpdates =
  (dataType, year, month, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const { data } = await axios.get(
        `${baseUrlNode}${api.Auth_Api.ALL_UPDATES_API}/${dataType}/${year}/${month}`
      );
      dispatch({
        type: types.AuthTypes.ALL_UPDATE,
        payload: data
      });
    } catch (updateError) {
      const errorData = {
        data: updateError.response.data,
        status: updateError.response.status
      };
      dispatch({
        type: types.AuthTypes.AUTH_GET_ERRORS,
        payload: errorData
      });
    }
  };

// add - updates
const addUpdates = (value, loginType) => async (dispatch) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const { data } = await axios.post(
      `${baseUrlNode}${api.Auth_Api.ADD_UPDATES_API}`,
      value
    );
    dispatch({
      type: types.AuthTypes.ADD_UPDATE,
      payload: data
    });
  } catch (updateError) {
    const errorData = {
      data: updateError.response.data,
      status: updateError.response.status
    };
    dispatch({
      type: types.AuthTypes.AUTH_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  changeAccess,
  getAccessData,
  setAccessLoading,
  clearAccessErrors,
  clearAccessResult,
  unmountAccessData,
  createAccessControl,
  deleteAccessControl,
  selectedModuleAccess,
  setAccessCreateLoading,
  getEmployeeAccess,
  getAllUsersForAccess,
  getAllUpdates,
  addUpdates
};
